import { Spinner } from 'reactstrap';
import styled from 'styled-components';

interface LoadingSpinnerProps {
  /** keep white space for loader for preventing page jump* */
  keepPosition?: boolean
  showLoader?: boolean
  size?: string
}

const Loader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const EmptyLoaderContainer = styled.div`
    height: 32px;
`;

const LoadingSpinner = ({ keepPosition, showLoader = true, size }: LoadingSpinnerProps): JSX.Element | null => {
  if (keepPosition && !showLoader) {
    return (
      <Loader>
        <EmptyLoaderContainer />
      </Loader>
    );
  }

  if (!showLoader) {
    return null;
  }

  return (
    <Loader>
      <Spinner
        size={size || ''}
        data-testid="loading-spinner"
      />
    </Loader>
  );
};

export default LoadingSpinner;
